// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__yfA4m","box":"WorkspacesBox_box__cWjTe","node":"WorkspacesBox_node__1_G5y"};